/* P5 — Keep the price inside the .reset-atc-fill button in sync with the
 * customer's current selection: the מארז variant cards AND the תדירות
 * (one-time / subscribe & save) toggle.
 *
 * 2026-05-28 rewrite (fixes the button staying frozen at the default price):
 *   1. Subscription price: derive the discount ratio from the chooser using the
 *      DIRECT-child <bdi> (`.reset-sub-row__price > bdi`). The previous
 *      `.reset-sub-row__price bdi:last-of-type` matched the struck-through
 *      COMPARE price first, so the button showed the one-time price.
 *   2. Variant change: observe the STABLE `#price-{section}` container. Dawn
 *      rewrites that container's innerHTML on variant change, which detached the
 *      descendant `.price-item` node the old observer was bound to, so it never
 *      fired. We also read the price straight from the selected variant card.
 *   3. Single source of truth (`updateButtonPrice`) checks the subscription
 *      state every time, so the variant path and the subscription path never
 *      fight, and the combined case (subscription + a 2/3-month מארז) shows the
 *      correct discounted price.
 *
 * The button price is rebuilt in the clean `money_without_trailing_zeros`
 * style (₪129, ₪109.65) — never the raw PDP string, which on this store carries
 * the currency code (₪129.00 ILS).
 */
(function () {
  'use strict';

  function btnPriceEl() {
    return document.querySelector('[data-reset-atc-price]');
  }

  // Dawn's main PDP price element (carries the currency code on this store).
  function pdpPriceEl() {
    return document.querySelector(
      '.price--large .price-item--sale, .price--large .price-item--last, .price--large .price-item--regular'
    );
  }

  // The stable container whose innerHTML Dawn replaces on variant change.
  function priceContainer() {
    var el = pdpPriceEl();
    return el ? el.closest('[id^="price-"]') : document.querySelector('[id^="price-"]');
  }

  // Clean price text from the currently selected מארז card (already rendered
  // with money_without_trailing_zeros), e.g. "₪232".
  function selectedVariantPriceText() {
    var radio = document.querySelector('.reset-variant-radio:checked');
    var card = radio
      ? radio.closest('.reset-variant-card')
      : document.querySelector('.reset-variant-card--selected');
    var priceEl = card && card.querySelector('.reset-variant-price');
    return priceEl ? priceEl.textContent.trim() : null;
  }

  function parseNum(text) {
    if (!text) return NaN;
    return parseFloat(text.replace(/[^\d.,]/g, '').replace(/,/g, ''));
  }

  // Mirror Shopify's money_without_trailing_zeros: ₪ prefix, drop trailing zeros.
  function formatPrice(n) {
    return '₪' + String(Math.round(n * 100) / 100);
  }

  // Subscription discount ratio (sub / one-time), read from the chooser so the
  // 15% is never hard-coded. Uses the approved direct-child <bdi> selector.
  var subRatio = null;
  function deriveSubRatio() {
    var oneTimeEl = document.querySelector('[data-sub-row="onetime"] .reset-sub-row__price > bdi');
    var subEl = document.querySelector('[data-sub-row="subscription"] .reset-sub-row__price > bdi:last-of-type');
    if (!oneTimeEl || !subEl) return;
    var o = parseNum(oneTimeEl.textContent);
    var s = parseNum(subEl.textContent);
    if (o > 0 && s > 0) subRatio = s / o;
  }

  function subscriptionSelected() {
    var r = document.querySelector('.reset-sub-row__radio:checked');
    return !!(r && r.value && r.value.trim() !== '');
  }

  // Resolve the current one-time price (variant card first, PDP price fallback).
  function currentOneTimeNum() {
    var cardText = selectedVariantPriceText();
    var n = parseNum(cardText);
    if (!isNaN(n)) return n;
    var src = pdpPriceEl();
    return src ? parseNum(src.textContent) : NaN;
  }

  function updateButtonPrice() {
    var btn = btnPriceEl();
    if (!btn) return;

    // One-time: prefer the clean card text verbatim (no reformatting needed).
    if (!subscriptionSelected()) {
      var cardText = selectedVariantPriceText();
      if (cardText) {
        if (cardText !== btn.textContent.trim()) btn.textContent = cardText;
        return;
      }
    }

    var oneTime = currentOneTimeNum();
    if (isNaN(oneTime)) return;
    var value = subscriptionSelected() && subRatio ? oneTime * subRatio : oneTime;
    var txt = formatPrice(value);
    if (txt !== btn.textContent.trim()) btn.textContent = txt;
  }

  function init() {
    deriveSubRatio();
    updateButtonPrice();

    var container = priceContainer();
    if (container) {
      new MutationObserver(updateButtonPrice).observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Delegated so the handlers survive Dawn re-rendering the variant cards.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && (t.classList.contains('reset-variant-radio') || t.classList.contains('reset-sub-row__radio'))) {
        updateButtonPrice();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
